import React from 'react';
import styles from '../dra_rebeccaalmeida/dra_rebeccaalmeida.module.scss';
import Background from './src/background-links.png';
import LinkPersonalizado7 from '../../components/LinkPersonalizado7/linkPersonalizado7.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import CatalogIcon from '../../icons/catalogIcon.tsx';

const Dra_rebeccaalmeida: React.FC = () => {
    return (
        <div className={styles.dra_rebeccaalmeida}>
            <div className={styles["body-thunder"]} style={{
                backgroundImage: `url(${Background})`
            }}>
                <div
                    className={styles["container-thunder"]}
                >
                    <h1 className="pt-2">Dra. Rebecca Almeida</h1>
                    <p>CIRURGIÃ DENTISTA</p>
                    <hr className={styles.welcomeDivider} />
                    <div className={styles.welcomeIntro}>
                        <p>Olá, seja bem-vindo(a)!</p>
                        <p>Eu sou a Dra. Rebecca Almeida. 🦷✨</p>
                        <p>
                            Sou cirurgiã-dentista e minha missão é transformar sorrisos e elevar a autoestima dos meus
                            pacientes.
                        </p>
                        <p>
                            Atuo em clínica geral e harmonização orofacial, unindo saúde, estética e naturalidade para
                            que você sorria com mais confiança e se sinta bem ao se olhar no espelho.
                        </p>
                        <p>
                            Nos links abaixo você encontra todos os tratamentos que realizo e formas de agendar sua
                            avaliação.
                        </p>
                        <p>Será um prazer cuidar do seu sorriso.</p>
                    </div>
                    <div className={styles.links}>
                        <LinkPersonalizado7
                            href="https://wa.me/5516992351900?text=Olá, gostaria de agendar um horário..."
                            title="WHATSAPP"
                            icon={<WhatsappIcon height="40" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="https://maps.app.goo.gl/PnipzwaEp5RPr1e79"
                            title="LOCALIZAÇÃO"
                            icon={<MapsIcon height="40" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="https://www.instagram.com/dra.rebeccaalmeida?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            title="INSTAGRAM"
                            icon={<div style={{
                                width: "max-content",
                                paddingBottom: "5px",
                                borderRadius: "100%",
                            }}><InstagramIcon height="32" color="#ffffff" /></div>}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="/dra_rebeccaalmeida/procedimentos"
                            title="PROCEDIMENTOS"
                            icon={<CatalogIcon height="40" color="#ffffff" />}
                            colorText="#cbb353"
                            linkInterno={true}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dra_rebeccaalmeida;
